import React from 'react'

export default function HeroBackground() {
  return (
    <div className="hero-aurora-fullscreen" aria-hidden="true">
      <div className="hero-aurora-fullscreen-layer1" />
      <div className="hero-aurora-fullscreen-layer2" />
      <div className="hero-aurora-fullscreen-layer3" />
      <div className="hero-aurora-fullscreen-orb-wrap">
        <div className="hero-aurora-fullscreen-orb-pressure" />
        <div className="hero-aurora-fullscreen-orb-glow" />
        <div className="hero-aurora-fullscreen-orb-core" />
        <div className="hero-aurora-fullscreen-orb" />
      </div>
    </div>
  )
}
